export default function PageJsonLd() {
  const serviceSchema = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'Тренинг по продажам для сотрудников',
    provider: {
      '@type': 'Person',
      name: 'Алексей Сивко',
      description: 'Бизнес-тренер с более чем 18-летним опытом в продажах и переговорах',
      url: 'https://sivko.by/',
    },
    description: 'Корпоративный тренинг по продажам для сотрудников и отделов продаж. Практическое обучение с диагностикой, реальными кейсами, сопровождением внедрения.',
    areaServed: ['Беларусь', 'Россия', 'Казахстан', 'Израиль'],
    serviceType: 'Корпоративное обучение продажам',
    offers: {
      '@type': 'Offer',
      availability: 'https://schema.org/InStock',
      category: 'Корпоративный тренинг',
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: 'Что входит в программу тренинга по продажам?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Программа включает диагностику текущих показателей отдела продаж, изучение бизнес-процессов компании, прослушивание реальных звонков, анализ переписок, интервью с сотрудниками, подготовку индивидуальной программы, практический тренинг на реальных кейсах компании, домашние задания, разбор звонков и переписок, работу с руководителем отдела, посттренинговое сопровождение и поддержку внедрения изменений.',
        },
      },
      {
        '@type': 'Question',
        name: 'Сколько длится корпоративный тренинг по продажам?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Продолжительность зависит от выбранного формата. Интенсив может длиться 1–2 дня, модульное обучение — от 2 недель до 3 месяцев, а комплексная программа с сопровождением — от 1 до 6 месяцев. Точная продолжительность определяется после диагностики и согласования целей.',
        },
      },
      {
        '@type': 'Question',
        name: 'Как измерить эффективность тренинга по продажам?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Эффективность измеряется по конкретным KPI: рост конверсии, увеличение среднего чека, снижение процента скидок, рост повторных продаж, сокращение цикла сделки, рост количества квалифицированных лидов. Мы фиксируем исходные показатели до тренинга и отслеживаем динамику после.',
        },
      },
      {
        '@type': 'Question',
        name: 'Можно ли провести тренинг по продажам онлайн?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Да, корпоративный тренинг по продажам проводится в онлайн-формате с использованием интерактивных инструментов, практических заданий, разбора реальных кейсов и ролевых игр. Онлайн-формат не уступает очному по эффективности при правильной организации.',
        },
      },
      {
        '@type': 'Question',
        name: 'Для каких компаний подходит тренинг по продажам?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Тренинг подходит для компаний из сфер B2B и B2C: производство, услуги, IT, логистика, строительство, медицина, ритейл, образование, финансы, телеком. Программа адаптируется под специфику отрасли, продукта и цикла продаж.',
        },
      },
      {
        '@type': 'Question',
        name: 'Чем ваш тренинг по продажам отличается от других?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Ключевые отличия: предварительная диагностика и аудит, отсутствие шаблонных программ, работа с реальными кейсами и звонками компании, 80% практики, сопровождение после тренинга, создание книги продаж, личный опыт тренера в продажах (18+ лет), работа в поле вместе с сотрудниками.',
        },
      },
      {
        '@type': 'Question',
        name: 'Сколько стоит корпоративный тренинг по продажам?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Стоимость зависит от формата, продолжительности, количества участников и специфики задач. Каждая программа разрабатывается индивидуально. Для получения точного расчёта оставьте заявку — мы проведём бесплатную экспресс-диагностику и подготовим предложение.',
        },
      },
      {
        '@type': 'Question',
        name: 'Даёте ли вы гарантию результата после тренинга?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Мы гарантируем рост показателей при условии внедрения всех рекомендаций и прохождения полного цикла: диагностика → обучение → сопровождение. Наши кейсы подтверждают рост конверсии на 18–55% при комплексном подходе. Результат — это совместная работа тренера, сотрудников и руководителя.',
        },
      },
      {
        '@type': 'Question',
        name: 'Нужно ли участвовать руководителю отдела продаж в тренинге?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Да, участие руководителя отдела продаж критически важно. Он получает инструменты для контроля качества, наставничества и поддержки изменений после тренинга. Без вовлечения руководителя эффективность обучения снижается в 2–3 раза.',
        },
      },
      {
        '@type': 'Question',
        name: 'Как проходит посттренинговое сопровождение?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Сопровождение включает регулярные встречи с руководителем, выборочный аудит звонков и переписок, корректировку скриптов, ответы на вопросы сотрудников в чате, контроль внедрения книги продаж. Длительность сопровождения — от 1 до 6 месяцев в зависимости от программы.',
        },
      },
    ],
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Главная',
        item: { '@id': 'https://business-training.by/', name: 'Главная' },
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: 'Продажи и переговоры',
        item: { '@id': 'https://business-training.by/prodazhi-i-peregovory/trening-po-prodazham', name: 'Продажи и переговоры' },
      },
    ],
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(serviceSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }} />
    </>
  );
}